import React from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { Button, Modal } from "semantic-ui-react";
import { toast } from "../..";
import { deleteCrewMember } from "../../api/crewMembers";

type Props = {
    open: boolean;
    closeModal: () => void;
    crewMemberGuid: string;
};

export const DeleteCrewMemberModal = ({ open, closeModal, crewMemberGuid }: Props) => {
    const history = useHistory();
    const intl = useIntl();

    const handleDeleteCrewMember = async () => {
        try {
            await deleteCrewMember(crewMemberGuid);
            toast(intl.formatMessage({ id: "crewMemberDeleted" }), true);
            history.push("/");
        } catch {
            toast(intl.formatMessage({ id: "deleteCrewMember" }), false);
        } finally {
            closeModal();
        }
    };

    return (
        <Modal open={open} onClose={() => closeModal()} dimmer="blurring" size="tiny">
            <Modal.Header>
                {intl.formatMessage({ id: "areYouSureDeleteCrewMemberData" })}
            </Modal.Header>
            <Modal.Actions>
                <Button
                    negative
                    onClick={() => closeModal()}
                    content={intl.formatMessage({ id: "cancel" })}
                />
                <Button
                    primary
                    onClick={() => handleDeleteCrewMember()}
                    content={intl.formatMessage({ id: "confirm" })}
                />
            </Modal.Actions>
        </Modal>
    );
};
